import b from 'b_';
import LessonMeta from 'platform-components/src/components/lesson-meta';
import React from 'react';

import './lessons__lesson-date-assignment.scss';

interface LessonDateAssignmentProps {
    dateAssignment?: string | null;
    dateDeadline?: string | null;
}

export const LessonDateAssignment = ({ dateAssignment, dateDeadline }: LessonDateAssignmentProps) => {
    let dates: string | React.ReactNode = '–';

    if (dateAssignment) {
        dates = (
            <LessonMeta.Date
                endDate={dateDeadline ? new Date(dateDeadline) : null}
                startDate={new Date(dateAssignment)}
            />
        );
    }

    return (
        <div className={b('lessons', 'lesson-date-assignment', { 'has-dates': Boolean(dateAssignment) })}>{dates}</div>
    );
};

export default LessonDateAssignment;
